import React from "react";
import { Container, Title } from "./styled";

export const Header = () => {
  return (
    <Container>
      <Title>Tech Finanças</Title>
    </Container>
  );
};
